import { BillingmanageEdit, ExportBillingmanage,ExportBillingmanageGold,ConfirmBill,ExportBillingmanageDiamonds,BillingmanageRollback } from "@a/billingmanage.js";
import Cookies from "js-cookie"
//cookies
import { setToken, setUsername, getUsername, getToken, removeToken, removeUsername } from "../../utils/cookies";
const state ={
    token: "" || getToken(),
    username: "" || getUsername(),
}
const getters ={}
const mutations ={
    SET_TOKEN(state, value){ // 设置 token
        state.token = value;
        value && setToken(value);
    },
    SET_USERNAME(state, value){ // 设置用户名
        state.username = value;
        value && setUsername(value);
    },
}
const actions ={
    editAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            BillingmanageEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    rollbackAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            BillingmanageRollback(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    exportAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            ExportBillingmanage(repuestData).then((response) => {
                // 获取头文件中的内容为了读取后端发送文件的文件名
        var disposition = response.headers['content-disposition']
        var fileName = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))
        // 创建blob流并将数据添加进去，根据不同类型文件设置不同的type，excel就设置这种type就可以了
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }) // 假设文件为pdf
        // 创建组件并点击，地址为流地址，之后销毁掉
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
            }).catch(error => {
                reject(error);
            })
        })
    },
    exportGoldAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            ExportBillingmanageGold(repuestData).then((response) => {
                // 获取头文件中的内容为了读取后端发送文件的文件名
        var disposition = response.headers['content-disposition']
        var fileName = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))
        // 创建blob流并将数据添加进去，根据不同类型文件设置不同的type，excel就设置这种type就可以了
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }) // 假设文件为pdf
        // 创建组件并点击，地址为流地址，之后销毁掉
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
            }).catch(error => {
                reject(error);
            })
        })
    },
    exportDiamondsAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            ExportBillingmanageDiamonds(repuestData).then((response) => {
                // 获取头文件中的内容为了读取后端发送文件的文件名
        var disposition = response.headers['content-disposition']
        var fileName = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))
        // 创建blob流并将数据添加进去，根据不同类型文件设置不同的type，excel就设置这种type就可以了
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }) // 假设文件为pdf
        // 创建组件并点击，地址为流地址，之后销毁掉
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
            }).catch(error => {
                reject(error);
            })
        })
    },
    confirmAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            ConfirmBill(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};